import { render, staticRenderFns } from "./sell.vue?vue&type=template&id=4f568ef4&scoped=true&"
import script from "./sell.vue?vue&type=script&lang=js&"
export * from "./sell.vue?vue&type=script&lang=js&"
import style0 from "./sell.vue?vue&type=style&index=0&id=4f568ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f568ef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4f568ef4', component.options)
    } else {
      api.reload('4f568ef4', component.options)
    }
    module.hot.accept("./sell.vue?vue&type=template&id=4f568ef4&scoped=true&", function () {
      api.rerender('4f568ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/flow-form/sell.vue"
export default component.exports